<template>
  <div class="page">
    <div class="router">
      <div @click="$router.go(-1)" class="back">
        <a-icon type="left"></a-icon>
        <div class="name">返回</div>
      </div>
      <div class="extra">
        <a-space v-if="id">
          <!-- <div style="font-size: 12px;">上次保存 {{ saveTime }}</div> -->
          <!-- <a-button size="small" @click="handlePush('draft')" shape="round"
            >暂存</a-button
          > -->
          <a-button
            type="primary"
            shape="round"
            @click="handlePush('official')"
            size="small"
            >确认编辑</a-button
          >
        </a-space>
        <a-space v-else>
          <!-- <div style="font-size: 12px;">上次保存 {{ saveTime }}</div>
          <a-button size="small" @click="handlePush('draft')" shape="round"
            >暂存</a-button
          > -->
          <a-button
            type="primary"
            shape="round"
            @click="handlePush('official')"
            size="small"
            >立即发布</a-button
          >
        </a-space>
      </div>
    </div>

    <div class="srcoll">
      <div class="head flex-row">
        <div class="title">{{ id ? "编辑" : "发布" }}观察任务</div>
      </div>

      <section class="section">
        <div class="z-title">任务对象 <span>*</span></div>
        <div class="content">
          <a-space style="width: 100%;flex-wrap: wrap;">
            <a-button
              @click="handleDelStudent(index)"
              v-for="(item, index) in students"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;margin-bottom: 10px"
              >{{ item.name }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button
              style="margin-bottom: 10px"
              shape="round"
              size="small"
              @click="showAddStudents = true"
              ><a-icon type="plus" />选择添加孩子</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">关联领域</div>
        <div class="content">
          <a-space>
            <a-button
              @click="range.splice(index, 1)"
              v-for="(item, index) in range"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showRange = true"
              ><a-icon type="plus" />添加/选择关联领域</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">发展阶段</div>
        <bea-list
          :list="beas"
          @del="handleDelBea"
          @edit="handleEditbeva(item)"
          labelPos="block"
          backgroundColor="#fff"
        ></bea-list>
        <div
          class="content"
          :style="{ marginTop: beas.length ? '0px' : '20px' }"
        >
          <a-space>
            <a-button
              @click="form.level.splice(index, 1)"
              v-for="(item, index) in form.level"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="handleAddbeva"
              ><a-icon type="plus" />添加行为表现</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        
        <section  class="z-item" style="margin-bottom: 10px;">
          <div class="z-title">任务主题<span>*</span></div>
          <div class="input">
          <a-textarea
            placeholder="填写主题内容"
            v-model="form.record_text"
            :rows="4"
            :maxLength="3000"
            style="border: none;"
          />
          <div class="number">{{ form.record_text.length }}/3000</div>
        </div>

        </section>
      </section>

      <section class="section">
        <div class="z-title">任务发布时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            @change="onChangeDate"
            v-model="form.start_time"
          />
        </div>
      </section>

      <section class="section">
        <div class="z-title">任务结束时间 <span>*</span></div>
        <div class="content">
          <a-date-picker
            show-time
            @change="onChangeEndDate"
            v-model="form.end_time"
          />
        </div>
      </section>

      <a-modal
        width="720px"
        :visible="showRange"
        @cancel="showRange = false"
        @ok="handleAddRange"
        title="选择领域"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in rangeList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group v-model="rangeCheckedList[index]">
            <a-row>
              <a-col
                v-for="(range, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox :value="range.name">
                  {{ range.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>
    </div>

    <a-modal
      :visible="showRange"
      @cancel="showRange = false"
      @ok="handleAddRange"
      title="选择领域"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-checkbox-group v-model="rangeCheckedList[index]">
          <a-row>
            <a-col
              v-for="(range, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-checkbox :value="range.name">
                {{ range.name }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </a-modal>


    <a-modal
      width="720px"
      :visible="showAddStudents"
      @cancel="showAddStudents = false"
      @ok="handleAddStudents"
      title="选择孩子"
      :bodyStyle="{ padding: '10px 20px' }"
      centered
    >
      <a-row>
        <a-checkbox :checked="checkAll" @change="handleSelectAllStudents">
          全部
        </a-checkbox>
      </a-row>
      <div v-for="(item, index) in studentList" :key="index" class="range">
        <div class="Up">{{ item.group_name }}</div>
        <!-- <a-checkbox-group @change="handleCancelAllStudents"> -->
        <a-row>
          <a-col
            v-for="(child, index2) in item.student"
            :key="index2"
            :span="6"
          >
            <a-checkbox
              @change="handleChangeSelectChild(child)"
              :checked="child.checked"
              :value="child.id"
            >
              {{ child.name }}
            </a-checkbox>
          </a-col>
        </a-row>
        <!-- </a-checkbox-group> -->
      </div>
    </a-modal>

    <a-modal
      :visible="showBea"
      @cancel="showBea = false"
      @ok="handleAddBea"
      title="选择表现行为"
      centered
      width="720px"
      :bodyStyle="{ padding: '10px 20px' }"
    >
      <div v-for="(item, index) in rangeList" :key="index" class="range">
        <div class="Up">{{ item.name }}</div>
        <a-radio-group
          v-model="bea"
          name="bea"
          @change="handleChangeBea($event, item)"
          style="width: 100%;"
        >
          <a-row style="position: relative;">
            <a-col
              v-for="(child, index2) in item.childs"
              :key="index2"
              :span="6"
            >
              <a-radio
                :class="bea == child.name ? 'select-this' : ''"
                :value="child.name"
              >
                {{ child.name }}
              </a-radio>

              <div
                class="select"
                v-if="bea == child.name"
                style="width: 680px;overflow: hidden;padding: 5px 0;padding-top: 6px;border-top: 1px solid #6fb0dc;font-size: 12px;margin-top: 14px"
                :style="{ marginLeft: -(index2 / 4) * 680 + 'px' }"
              >
                <a-radio-group
                  @change="handleSelectBea2($event, child)"
                  style="width: 680px;"
                  name="bea2"
                >
                  <a-row>
                    <a-radio
                      v-for="(child2, index3) in child.childs"
                      :key="index3"
                      name="bea2"
                      style="font-size: 12px;color: #67b0dc"
                      @change="handleSelectBea3($event, child2)"
                      :value="child2.name"
                    >
                      {{ child2.name }}
                    </a-radio>
                  </a-row>
                </a-radio-group>
              </div>
            </a-col>
          </a-row>
        </a-radio-group>
      </div>
    </a-modal>

    <add-level
      :show="openBea"
      @add="handleConfirmAddBea"
      :data="selectBeaForm"
      @close="openBea = false"
    ></add-level>
  </div>
</template>

<script>
import axios from "axios";
import beaList from "../../../components/bea-list-add.vue";
import { mapActions } from "vuex";
import qs from "qs";
import _ from "lodash";
import addLevel from "./add-level.vue";
import { leaderApi as directorTestApi } from "../../../api/api-director";
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      saveTime: "",
      data: null,
      directorTestApi,
      bea: "",
      showBea: false,
      checkAll: false,
      showPlate: false,
      selectBeaForm: null,
      cj: [],
      strategy_att2: [],
      record_att: [
        {
          record_text: "",
          fileList: [],
          fileList2: [],
        },
      ],
      form: {
        data_type: "official",
        field_id: "",
        start_time: null,
        end_time:null,
        range: [],
        status: 1,
        class_id:"",
        record_text:"",
        student_id:"",
        targets: "",
        leader_id:""
      },
      students: [],
      selectType: 1,
      loading: false,
      fileList: [],
      fileList2: [],
      showAddStudents: false,
      showAddCj: false,
      activeCl: null,
      studentList: [],
      checkedList: [],
      showRange: false,
      rangeCheckedList: [],
      active: 0,
      rangeList: [],
      range: [],
      activity: [],
      activityList: [
      ],
      showActivity: false,
      activityCheckedList: [],
      cjCheckedList: [],
      cjList: [
      ],
      SelectBea: null,
      customStyle:
        "background: #fff;border-radius: 4px;border: 0;overflow: hidden;font-weight:bold",
      activeKey: 0,
      showClDetail: false,
      clList: [],
      openBea: false,
      beaSelect: null,
      beas: [],
      targets: [],
      showSelef: false,
      id: "",
    };
  },

  components: {
    beaList,
    addLevel,
  },
  computed: {
    ...mapState(["currentClass", "userInfo","school"]),
    formContent() {
      if (
        this.form.start_time &&
        this.form.record_text && this.form.end_time && this.students && this.students.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    showAddStudents(val) {
      if (val) {
        const students = this.students.map((item) => {
          return item.id;
        });
        this.studentList.forEach((group, index) => {
          group.student.forEach((item) => {
            if (students.includes(item.id)) {
              item.checked = true;
            }
          });
        });
      }
    },
    showRange(val) {
      if (val) {
        if (this.rangeList.length) {
          this.rangeList.forEach((group, index) => {
            this.rangeCheckedList[index] = [];
            group.childs.forEach((item) => {
              if (this.range.includes(item.name)) {
                this.rangeCheckedList[index].push(item.name);
              }
            });
          });
          this.$forceUpdate();
        } else {
          this.$message.info("领域加载中，如未更新状态，请重试");
          setTimeout(() => {
            this.rangeList.forEach((group, index) => {
              this.rangeCheckedList[index] = [];
              group.childs.forEach((item) => {
                if (this.range.includes(item.name)) {
                  this.rangeCheckedList[index].push(item.name);
                }
              });
            });
            this.$forceUpdate();
          }, 2000);
        }
      }
    },
    userInfo() {
      if (this.userInfo) {
        if (this.currentClass) {
          this.getAllStudents();
        } else {
          this.getClassList();
        }
        this.init();

        if (this.$route.query.id) {
          this.getDetail(this.$route.query.id);
        }
      }
    },
    form() {
      if (
        this.$route.query.id &&
        this.cjList.length &&
        this.activityList.length &&
        this.rangeList.length
      ) {
        _.debounce(this.handlePush("draft"), 10000);
      }
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.form.id = this.$route.query.id;
    if (!this.$route.query.id) {
      this.form.start_time = moment().format("YYYY-MM-DD HH:mm:ss");
    } else if (this.userInfo) {
      this.getDetail(this.$route.query.id, this.$route.query.type);
    }

    if (this.userInfo) {
      if (this.currentClass) {
        this.getAllStudents();
      } else {
        this.getClassList();
      }
      this.init();
    }
  },
  methods: {
    getDetail(id) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url: directorTestApi.main + directorTestApi.getObserTaskDetail,
            headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        method: "POST",
        data: qs.stringify({
          id,
          leader_id: this.userInfo.id,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "获取成功",
            key: "loading",
            duration: 0.5,
          });
          const data = res.data.data;
          this.data = res.data.data;
          this.saveTime = data.addTime;
          this.form = {
            id: data.id,
            start_time: moment(data.record_time).format("YYYY-MM-DD HH:mm:ss"),
            teacher_name: data.teacher_name,
            field_id: "",
            end_time: data.end_time,
            range: [],
            status: 1,
            class_id:"",
            record_text: data.record_text,
            student_id:"",
            targets: "",
            leader_id:""
          };
          this.students = data.students;


          this.range = data.fields.map((item) => item.target_name);
          this.beas = data.target2;
          this.showModal = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRemove() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "提示",
          content: "确定要删除吗？",
          centered: true,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          },
        });
      });
    },
    handleDelSelef(type, id) {
      axios({
        url:
          type == "scene"
            ? directorTestApi.main + directorTestApi.saveDeleteObserSelfScene
            : directorTestApi.main + directorTestApi.saveDeleteObserSelfAct,
        method: "post",
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          leader_id: this.userInfo.id,
          id,
          school_id: this.school.id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "删除成功",
          });
          if (type == "scene") {
            this.getSelefScenes();
          } else {
            this.getSelefActs();
          }
        } else {
          this.$message.error({ content: res.data.message });
        }
      });
    },
    handleDelStudent(index) {
      if (this.students[index].name == '全部') {
        this.checkAll = false
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = false;
          });
        });
        this.students.splice(index, 1);
      } else {
        this.students.splice(index, 1);
        this.checkAll = false
      }
    },
    handleAddSelef(type) {
      this.selefType = type;
      this.showSelef = true;
    },
    handleAddSelefOk() {
      this.$message.loading({
        content: "正在添加...",
        key: "addSelef",
      });
      axios({
        url:
          this.selefType == "scene"
            ? directorTestApi.main + directorTestApi.saveObserSelfScene
            : directorTestApi.main + directorTestApi.saveObserSelfAct,
        method: "post",
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          leader_id: this.userInfo.id,
          name: this.selef_name,
          school_id: this.school.id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "添加成功",
            key: "addSelef",
          });
          this.selefType == "scene"
            ? this.getSelefScenes()
            : this.getSelefActs();
          this.showSelef = false;
          this.selef_name = "";
        } else {
          this.$message.error({ content: res.data.message, key: "addSelef" });
        }
      });
    },
    getSelefScenes() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfSceneList,
        method: "post",
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          leader_id: this.userInfo.id,
          school_id: this.school.id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_scenes = res.data.data;
          this.selef_scene_ids = this.selef_scene_ids.filter((name) => {
            if (this.selef_scenes.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_scenes = [];
        }
      });
    },
    getSelefActs() {
      axios({
        url: directorTestApi.main + directorTestApi.getObserSelfActList,
        method: "post",
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          leader_id: this.userInfo.id,
          school_id: this.school.id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.selef_acts = res.data.data;
          this.selef_act_ids = this.selef_act_ids.filter((name) => {
            if (this.selef_acts.map((item) => item.name).includes(name)) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.selef_acts = [];
        }
      });
    },
    handleDelBea(index, index2) {
      console.log(index, index2);
      this.beas[index].targets.splice(index2, 1);
      this.$forceUpdate();
    },
    handleConfirmAddBea(list) {
      list.forEach((item) => {
        if (this.beas.map((item2) => item2.id).includes(item.id)) {
          this.beas.forEach((detail) => {
            if (detail.id == item.id) {
              //学生id重复
              item.targets.forEach((target1) => {
                if (
                  detail.targets.map((item3) => item3.id).includes(target1.id)
                ) {
                  // 一级二级重复
                  //根据id判断item.targets.targets和detail.targets.targets下面列表是否重复,重复只保留一个
                  target1.targets.forEach((target2) => {
                    const detail2 = detail.targets.find(
                      (item4) => item4.id == target1.id
                    );
                    const ids = detail2.targets.map((item3) => item3.id);
                    if (ids.includes(target2.id)) {
                    } else {
                      detail2.targets.push(target2);
                    }
                  });
                } else {
                  detail.targets.push(target1);
                }
              });
            }
          });
        } else {
          this.beas.push(item);
        }
      });
      console.log(this.beas);
      this.openBea = false;
    },
    handleChangeSelectChild(child) {
      child.checked = !child.checked;
      if (!child.checked) {
        this.checkAll = false
      }
      this.$forceUpdate();
    },
    onChangeDate(e, date) {
      console.log(e, date);
      this.form.start_time = date;
    },
    onChangeEndDate(e, date) {
      console.log(e, date);
      this.form.end_time = date;
    },
    init() {
      this.getSceneList();
      this.getRangeList();
    },
    getSceneList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
        leader_id: this.userInfo.id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserSceneList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.cjList = res.data.data;
      });
    },
    getRangeList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
        leader_id: this.userInfo.id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getFieldList,
        headers: { "content-type": "application/x-www-form-urlencoded" ,Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...form,
          school_id: this.school.id || "",
        }),
      }).then((res) => {
        this.rangeList = res.data.data;
      });
    },
    getRebackList() {
      if (!this.currentClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.school.id || "",
        grade_id: this.currentClass.grade_id,
        leader_id: this.userInfo.id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRebackList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.clList = res.data.data;
      });
    },
    getGuideList() {
      if (!this.currentClass) {
        return;
      }
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.school.id || "",
        grade_id: this.currentClass.grade_id,
        leader_id: this.userInfo.id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserGuideList,
        headers: { "content-type": "application/x-www-form-urlencoded" ,Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.guideList = res.data.data;
      });
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        leader_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.school.id || "",
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: { "content-type": "application/x-www-form-urlencoded" ,Authorization: this.$store.state.headers},
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
        this.className = this.classList[0].class_name;
        this.$store.state.currentClass = this.classList[0];
        this.getAllStudents();
      });
    },
    getAllStudents() {
      this.studentListForm = {
        class_id: this.currentClass.id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        leader_id: this.userInfo.id,
        school_id: this.school.id || "",
      };

      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getGroupStudentList,
        headers: { "content-type": "application/x-www-form-urlencoded" ,Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.studentList = [
          {
            label: "A",
            childs: res.data.data,
          },
        ];
        this.studentList = res.data.data;
      });
    },
    handleChangeBea(e, item) {
      this.selectBeaForm = {
        range: item.name,
      };
    },
    handleAddBea() {
      if (!this.selectBeaForm || !this.selectBeaForm.detail) {
        this.$message.error("请选择目标");
        return;
      }
      if (this.checkAll) {
        this.selectBeaForm.students = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);;
      } else {
        this.selectBeaForm.students = this.students;
      }
      
      this.selectBeaForm.students.map((item) => {
        item.bea = _.cloneDeep(this.selectBeaForm.detail);
        return item;
      });
      this.openBea = true;
      this.showBea = false;
    },
    handleEditbeva(studentBea) {
      console.log(studentBea);
      this.selectBeaForm = {
        detail: studentBea.bea,
        students: [studentBea],
      };
    },
    handleSelectBea2(e, child) {
      this.selectBeaForm = {
        range: this.selectBeaForm.range.split(">")[0] + ">" + child.name,
        rangeId: this.selectBeaForm.rangeId || "",
        detail: child.childs.filter((item) => item.name == e.target.value)[0],
        students: this.students.map((item) => {
          item.bea = _.cloneDeep(
            child.childs.filter((item) => item.name == e.target.value)[0]
          );
        }),
      };
    },
    handleSelectBea3(e, child) {
      console.log(e);
      this.selectBeaForm.rangeId = child.id;
    },
    handleCancelAllStudents() {
      this.checkAll = false;
    },
    handleSelectAllStudents(e) {
      this.checkAll = e.target.checked;
      if (e.target.checked) {
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = true;
          });
        });
      } else {
        this.students = [];
        this.studentList.forEach((element, index) => {
          element.student.forEach((el) => {
            el.checked = false;
          });
        });
      }
      this.$forceUpdate();
    },
    handleAddbeva() {
      if (this.students.length < 1) {
        this.$message.error("请先选择观察对象");
        return;
      }
      this.showBea = true;
      // this.$router.push("/observe/addLevel");
    },
    onChange(e) {
      console.log(e);
      this.checkedList = e;
    },
    handleAddRange() {
      console.log(this.rangeCheckedList);
      this.range = this.rangeCheckedList.flat();
      this.showRange = false;
    },
    handleAddStudents() {
      if (this.checkAll) {
        const students = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
        this.students = [{name:"全部",id:students.map(item=>item.id).join(",")}]
      } else {
        this.students = this.studentList
        .map((item) => item.student)
        .flat()
        .filter((item) => item.checked);
      }
      this.showAddStudents = false;
    },
    handleAddCj() {
      this.cj = this.cjCheckedList.flat();
      this.showAddCj = false;
      console.log(this.selef_scene_ids);
    },
    handleAddActivity() {
      this.activity = this.activityCheckedList.flat();
      this.showActivity = false;
    },
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    //策略家庭确认选择
    handleConfrimCl() {
      let content = "";
      if (this.showPush == "cl") {
          let mbIndex = 1;
        this.clList.forEach((item) => {
          let detailStr = "";
          item.childs.forEach((detail) => {
            if (detail.detail_id) {
              detailStr +=
                "第" +
                this.SectionToChinese(mbIndex) +
                " " +
                detail.name +
                "\n";
              mbIndex++;
              detail.childs.forEach((item) => {
                const label = detail.detail_id.filter(
                  (id) => item.id == id
                );
                if (label.length) {
                  detailStr += item.name + "\n";
                }
              });
            }
          });
          content += detailStr;
        });
        this.form.strategy = content;
      } else {
        let mbIndex = 1;
        this.guideList.forEach((item) => {
          let detailStr = "";
          item.childs.forEach((detail) => {
            if (detail.detail_id) {
              detailStr +=
                "第" +
                this.SectionToChinese(mbIndex) +
                " " +
                detail.name +
                "\n";
              mbIndex++;
              // let detailIndex = 1;
              detail.childs.forEach((item) => {
                const label = detail.detail_id.filter(
                  (id) => item.id == id
                );
                if (label.length) {
                  detailStr += item.name + "\n";
                }
              });
            }
          });
          content += detailStr;
        });
        this.form.guidance = content;
      }

      this.showPush = "";
    },
    handlePush(type) {
      if (this.saving) {
        this.$message.error('正在保存，请稍后再试')
        return
      }
      this.form.data_type = type;
      console.log(this.formContent,this.students,this.form);
      if (this.formContent || type == "draft") {
        this.form.student_id = this.students.map((item) => item.id).join(",");
        if (this.beas.length) {
          this.form.targets = JSON.stringify(
            this.beas.map((item) => {
              return {
                student_id: item.id,
                target_id: item.targets
                  .map((target1) => {
                    return target1.targets
                      .map((target2) => {
                        return target2.id;
                      })
                      .join(",");
                  })
                  .join(","),
              };
            })
          );
        }

        this.form.leader_id = this.userInfo.id;
        this.school_id = this.school.id || "";
        this.form.class_id = this.currentClass.id
        this.form.data_type = type

        const range_names = this.range.flat();
        const range_ids = [];
        this.rangeList.forEach((item) => {
          item.childs.forEach((range) => {
            if (range_names.includes(range.name)) {
              range_ids.push(range.id);
            }
          });
        });
        this.form.field_id = range_ids.join(",");

          this.$message.loading({
            content: type == "draft" ? "正在保存" : "正在提交",
            duration: 3,
            key: "submit",
          });
          this.saving = true
          this.school_id = this.school.id || "";
            axios({
              method: "post",
              url: directorTestApi.main + directorTestApi.saveObTask,
              headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
              data: qs.stringify(this.form),
            }).then((res) => {
              
              if (res.data.code == 1) {
                this.$message.success({
                  content: type == "draft" ? "保存成功" : "提交成功",
                  key: "submit",
                });

                if (type != "draft") {
                  setTimeout(() => {
                    this.$router.back();
                  }, 800);
                } else {
                  this.form.id = res.data.data.id;
                }
                setTimeout(() => {
                  this.saving = false
                }, 500);
              } else {
                this.$message.error({
                  content: res.data.message,
                  key: "submit",
                });
              }
            });
      } else {
        this.$message.error("请完善必填内容");
      }
    },
    handleUploadChange(info, key) {
      console.log(info);
      this[key] = info.fileList.map((item) => {
        if (!item.thumbUrl && item.status == "done") {
          item.thumbUrl =
            item.type.indexOf("audio") > -1
              ? require("../../../assets/director/record.png")
              : require("../../../assets/director/video.png");
        }
        return item;
      });
      console.log(this[key]);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-checkbox-group {
  width: 100%;
}
section.section {
  border-bottom: 1px solid #ececec;
  padding: 20px 0;

  .z-title {
    position: relative;
    padding-left: 10px;
    line-height: 1.2;
    font-size: 14px;
    color: #555;
    font-weight: bold;
    &::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 3px;
      background: #73b5de;
      height: 100%;
    }
    span {
      color: red;
      margin-left: 1px;
    }
    span.tip {
      color: #999;
      font-weight: 400;
      margin-left: 5px;
    }
  }

  .input {
    margin-top: 10px;
    position: relative;
    .number {
      position: absolute;
      right: 12px;
      bottom: 3px;
      font-size: 12px;
      color: #7a7a7a;
    }
  }

  .upload {
    margin-top: 10px;
    span {
      display: inline-block;
    }
  }
  .upload-tip {
    font-size: 12px;
    color: #999;
    width: 100%;
  }

  .content {
    margin-top: 20px;
  }
}

.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
  }
}

.page {
  height: 100%;
  max-width: 900px;
  position: relative;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll {
    height: calc(100% - 75px);
    overflow-y: auto;
    padding: 15px 20px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}

.drawer-select {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    width: 100%;
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      user-select: none;
      .item {
        font-size: 12px;
        width: 120px;
        height: 155px;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        color: #555;
        position: relative;
        font-size: 14px;
        box-shadow: 2px 3px 6px 3px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}

.selectCl {
  border: 1px solid #92b8cf !important;
  color: #fff !important;
  background: #7da2b9 !important;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}

.bea {
  margin-top: 10px;
  .mb {
    color: #598ebe;
    font-weight: bold;
    margin: 5px 0;
  }
  .students {
    margin: 10px 0;
  }
  .bea-list {
    width: 100%;
    .cell {
      padding: 5px 10px;
      border-radius: 20px;
      border: 1px solid #eee;
      margin: 8px 0;
      box-shadow: 0 0 2px 1px rgba($color: #000000, $alpha: 0.06);
    }
  }
}

.hr {
  height: 6px;
  background: #eee;
}

.cl-card {
  width: 100%;
  box-shadow: 0 0 3px 2px rgba($color: #000000, $alpha: 0.08);
  padding: 10px;
  border-radius: 8px;
  .item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .foot {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    font-size: 12px;

    .select {
      color: #999;
      margin-right: auto;
    }
  }
}

.clDetail {
  width: 100%;
  padding: 15px;
  .cl-title {
    font-size: 14px;
    font-weight: bold;
  }

  .cl-list {
    margin: 10px 0;
  }
}

.select-this {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    //倒三角
    width: 0;
    z-index: 20;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #90bce6 transparent;
    left: 42%;
    top: 24px;
  }
}
</style>
